module.exports = __webpack_public_path__ + "img/mana.32e6ed21.svg";